const genericError = "There was a problem submitting your payment"

export default function SubscriptionHelper({ subscriptionsPath, planId, productId }) {
  /**
   * @public
   * @param {{billing_details: {name: String, email: String}, card: StripeCardElement}|PaymentMethod} paymentMethodData
   * @param promoCode
   * @param price
   * @param onSuccess
   * @param onError
   */
  async function subscribe({ paymentMethod, promoCode, price, onSuccess, onError }) {
    await fetch(subscriptionsPath, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": window.App.authenticityToken,
      },
      body: JSON.stringify({
        plan_id: planId,
        product_id: productId,
        payment_method: paymentMethod.id,
        promo_code: promoCode,
        price,
      }),
      redirect: "error",
    })
      .then(result => {
        return result.json()
      })
      .then(async ({ error, errors, subscription, permissions }) => {
        const subscriptionError = error || (errors && errors[0])

        if (subscriptionError) {
          onError(subscriptionError)
        } else if (subscription?.status === "active" || subscription?.status === "trialing") {
          onSuccess(subscription, permissions, planId, promoCode)
        }
      })
      .catch(unexpectedError => {
        if (window.App.allowDebugErrorMessages) console.error(unexpectedError)

        onError(genericError)
      })
  }

  return { subscribe }
}
